// claude-code-shell-delegation-guard.ts — 06k C6/C6b (D2).
//
// Phiên chat Claude Code lái mission ghi quyết định là "ủy nhiệm", không bao giờ
// thành "người duyệt". Luật máy chống QUÊN (không chống người cố ý): trong shell
// mà Claude Code mở cho Bash tool (đo 1(k): `CLAUDECODE=1`), approve/answer/
// redirect/pause/resume thiếu `--delegated` ⇒ exit 1, không ghi directive.
// `env` luôn tiêm qua dep (mặc định process.env) để test không phụ thuộc biến
// của tiến trình test (B10 xoá biến ở setupFiles).
import { writeMachineReadableError } from "../machine-readable-json-output-contract.js";

/**
 * Biến Claude Code đặt cho Bash tool — nguồn duy nhất cho guard và setupFiles test (B10).
 * Security F-02(a): CÓ ĐỊNH NGHĨA là đủ (kể cả "0"/rỗng) — `CLAUDECODE=0 avatar …`
 * không còn lách; muốn bỏ hẳn phải `env -u`/`unset` (ngoài whitelist WHW ⇒ hỏi người).
 */
export const CLAUDE_CODE_SHELL_ENV_VARS = ["CLAUDECODE", "CLAUDE_CODE_ENTRYPOINT"] as const;

/** `--reason` cắt ở đây SAU khi redact (che trước, cắt sau — không để lộ tiền tố secret). */
export const DELEGATED_REASON_MAX_CHARS = 300;

export function isClaudeCodeShell(env: NodeJS.ProcessEnv): boolean {
  return CLAUDE_CODE_SHELL_ENV_VARS.some((name) => env[name] !== undefined);
}

export interface DelegationFlags {
  delegated?: boolean;
  reason?: string;
}

/**
 * Lý do từ chối, hoặc `undefined` khi được ghi. `reasonRequired`: approve/answer
 * (ủy nhiệm phải ghi căn cứ); redirect/pause/resume thì `--reason` tuỳ chọn.
 */
export function delegationRejection(
  env: NodeJS.ProcessEnv,
  flags: DelegationFlags,
  reasonRequired: boolean,
): string | undefined {
  if (flags.delegated !== true && isClaudeCodeShell(env)) {
    return (
      "Lệnh chạy trong shell Claude Code nhưng thiếu --delegated — quyết định của Claude phải " +
      'ghi là ủy nhiệm (--delegated --reason "…"). Người duyệt thật: chạy lệnh từ terminal ngoài Claude Code.'
    );
  }
  if (flags.delegated !== true && flags.reason !== undefined) {
    return "--reason chỉ dùng cùng --delegated.";
  }
  if (flags.delegated === true && reasonRequired && (flags.reason ?? "").trim() === "") {
    return '--delegated cần --reason "<căn cứ, ≤ 300 ký tự, không chứa giá trị nhạy cảm>".';
  }
  return undefined;
}

/** Từ chối lệnh control: exit 1 (qua exitCode — action vẫn test được), không ghi gì. */
export function rejectControlCommand(command: string, message: string, jsonOut: boolean): void {
  if (jsonOut) writeMachineReadableError(command, message);
  else process.stderr.write(`✗ ${message}\n`);
  process.exitCode = 1;
}
